import React from 'react';
import { Drawer, Alert, Button, Typography, Upload, Space } from 'antd';
import { IoCloudUploadOutline, IoDownloadOutline } from 'react-icons/io5';

const { Paragraph } = Typography;

interface BulkImportModalProps {
  open: boolean;
  onClose: () => void;
  onImport: () => void;
}

export const BulkImportModal: React.FC<BulkImportModalProps> = ({
  open,
  onClose,
  onImport,
}) => {
  return (
    <Drawer
      title="Bulk Import Customers"
      open={open}
      onClose={onClose}
      placement="bottom"
      height="60vh"
      footer={
        <div style={{ textAlign: 'right' }}>
          <Space>
            <Button onClick={onClose}>Cancel</Button>
            <Button type="primary" onClick={onImport} disabled>
              Import
            </Button>
          </Space>
        </div>
      }
    >
      <Paragraph type="secondary">
        Upload a CSV file to onboard multiple customers at once.
      </Paragraph>

      <Alert
        type="info"
        message="Required CSV Columns"
        description="Company Name, Contact Name, Email, Type (Trade Counter/Installer), Region, Discount %"
        style={{ marginBottom: 16 }}
      />

      <Upload
        accept=".csv"
        maxCount={1}
        beforeUpload={() => false}
      >
        <Button icon={<IoCloudUploadOutline />} block size="large">
          Choose CSV File
        </Button>
      </Upload>

      <div style={{ marginTop: 16 }}>
        <Button
          type="link"
          icon={<IoDownloadOutline />}
          size="small"
        >
          Download CSV Template
        </Button>
      </div>
    </Drawer>
  );
};
